import React from 'react';

import { Box } from '@mui/material';
import { User } from 'ts_shared';
import { useTranslation } from 'react-i18next';

import AutocompleteMultipleOptions from 'components/common/AutocompleteMultipleOptions';
import { FormFieldDescription } from 'components/common/Forms';
import { useResellersListQuery } from 'services/api/general';
import { ResourceFormProps } from 'types';
import ControllerWithError from 'libs/react-hook-form/ControllerWithError';
import { UserFormUserType } from '../../types';

interface IProps extends ResourceFormProps<User> {
  userType: UserFormUserType;
}

const UserResellerDropdown = ({ control, userType }: IProps) => {
  const { t } = useTranslation('common');
  const isInternalUsersPage = userType === 'internal';

  const { data: resellers } = useResellersListQuery(undefined, {
    skip: !isInternalUsersPage,
  });

  if (!isInternalUsersPage) return null;

  return (
    <Box sx={{ display: 'grid' }}>
      <FormFieldDescription
        title={t('settings.userResellers', 'User Resellers')}
        subtitle={t(
          'settings.resellersUserBelongsTo',
          'Resellers that the user belongs to',
        )}
        required
      />
      <ControllerWithError
        control={control}
        name="resellers"
        render={({ field: { onChange, value } }) => {
          return (
            <AutocompleteMultipleOptions
              id="user-reseller-dropdown"
              options={resellers || []}
              value={value || []}
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.id}
              onChange={(_, newValues) =>
                onChange(newValues.map((newValue) => newValue.id))
              }
              textFieldProps={{
                variant: 'standard',
              }}
            />
          );
        }}
      />
    </Box>
  );
};

export default UserResellerDropdown;
